export default {
  SET_SCREEN_INFORMATION(state, params) {
    state.screenInformation = params;
  }
};
